module.exports = __webpack_public_path__ + "img/qacard4.0a0ea3d9.png";